import React from "react";

const UserSvg = ({isActive}) => {
  return (
    <svg
      width="23"
      height="27"
      viewBox="0 0 23 27"
      fill={`${isActive ? '#FFD700': '#7B7B7B'}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.37661 27C2.99196 26.8808 2.58951 26.8005 2.22629 26.6351C0.765224 25.971 -0.0577793 24.5278 0.00316114 22.9339C0.0752639 21.0467 0.531111 19.2745 1.46664 17.6303C2.7304 15.4094 4.5387 13.7777 6.88702 12.7392C7.04028 12.6715 7.19413 12.6059 7.38178 12.5244C5.13996 10.7154 4.16913 8.41125 4.67083 5.58527C4.96377 3.93563 5.82659 2.57626 7.14767 1.52783C10.0487 -0.773936 14.0828 -0.391407 16.5029 2.11405C17.9528 3.61511 18.6114 5.42351 18.4379 7.49881C18.2648 9.57262 17.2834 11.2247 15.6157 12.5121C15.972 12.6748 16.3032 12.812 16.6218 12.9737C19.4573 14.4146 21.3957 16.6364 22.4259 19.625C22.8558 20.872 23.0625 22.1658 22.9834 23.4862C22.8787 25.2302 21.5145 26.6813 19.7723 26.9494C19.7228 26.9569 19.6764 26.9826 19.6284 27C14.2113 27 8.79397 27 3.37661 27ZM11.5155 24.9274C14.002 24.9274 16.4888 24.9142 18.9749 24.9328C20.2646 24.9424 21.0113 24.0009 20.9042 22.965C20.8653 22.5897 20.8563 22.2104 20.7992 21.8381C20.3838 19.1191 19.0329 16.947 16.731 15.4474C13.7597 13.5117 10.5727 13.2538 7.38118 14.8286C3.96429 16.5145 2.23383 19.3605 2.10591 23.1489C2.09686 23.4179 2.16956 23.7145 2.28812 23.958C2.62903 24.6581 3.24387 24.9283 4.0026 24.928C6.50689 24.9268 9.01118 24.9274 11.5155 24.9274ZM11.4874 11.7641C14.1703 11.7752 16.369 9.60826 16.385 6.93775C16.4007 4.28431 14.221 2.10626 11.5179 2.07481C8.86306 2.04396 6.63571 4.24207 6.62063 6.9075C6.60524 9.56393 8.7991 11.7531 11.4874 11.7641Z"
        // fill="#7B7B7B"
      />
    </svg>
  );
};

export default UserSvg;
